import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.array.some";

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import * as actionTypes from './action-types';
import WFModalRecord from './wf-modal-record';
export default (function (state, action) {
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case actionTypes.MODAL_REGISTER:
      {
        var id = payload.modalId,
            printable = payload.printable;
        return state.merge({
          modals: state.modals.push(new WFModalRecord({
            id: id,
            printable: printable
          })),
          topModalId: id,
          bottomModalId: state.modals.size === 0 ? id : state.bottomModalId,
          suppressPagePrint: state.suppressPagePrint || printable
        });
      }

    case actionTypes.MODAL_UNREGISTER:
      {
        var modalId = payload.modalId;
        var modals = state.modals.slice(0, state.modals.indexOf(modalId));
        return state.merge({
          modals: modals,
          topModalId: modals.last({}),
          bottomModalId: modals.first({}),
          suppressPagePrint: modals.some(function (_ref) {
            var printable = _ref.printable;
            return printable;
          })
        });
      }

    default:
      throw new Error("Unhandled form action: ".concat(type));
  }
});